module.exports = __webpack_public_path__ + "img/1.9fa1e6ea.svg";